export default class DesvincularPersonalDeCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idCursoPersonal) {
    try {
      const result = await this.#repository.desvincularPersonalDeCurso(idCursoPersonal)
      return result
    } catch (error) {
      throw error
    }
  }
}
